import { render, staticRenderFns } from "./time-material.vue?vue&type=template&id=4766a762&"
import script from "./time-material.vue?vue&type=script&lang=js&"
export * from "./time-material.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports